import ProductDescription from '../components/Pages/About/ProductDescription';
import FAQ from '../components/Pages/About/FAQ';
import CTASection from '../components/Pages/About/CTASection';
import TeamDescription from '../components/Pages/About/TeamDescription';
import Footer from '@/components/Footer';

export default function About() {
  return (
    <>
      <ProductDescription></ProductDescription>
      <FAQ></FAQ>
      <CTASection></CTASection>
      <TeamDescription></TeamDescription>
      <Footer></Footer>
    </>
  );
}

About.layout = 'Main';
